<template>
    <div class="docs-list" id="section-4" style="display: none">
        <h1>REST API</h1>
        <hr/>
        <p>REST API enables devices with capability of sending HTTP requests to interact with <a
            href="http://cloud.sensoro.com" target="_blank">SENSORO Cloud</a>.</p>

        <h3>Introduction</h3>

        <ol>
            <li>AuthType：HTTP Basic Auth</li>
            <li>URL： http://cloud-api.sensoro.com</li>
            <li>Account：<a href="http://cloud.sensoro.com" target="_blank">Sign up</a></li>
        </ol>


        <h3>I. Users</h3>

        <table>
            <thead>
            <tr>
                <th>URL</th>
                <th> HTTP</th>
                <th> Functionality</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>/sessions</td>
                <td> POST</td>
                <td> Email and passcode verification</td>
            </tr>
            </tbody>
        </table>


        <ol>
            <li><p>Email and passcode verification</p>

                <p><code>POST /sessions</code></p>

                <p><code>Parameters</code></p>

                <table>
                    <thead>
                    <tr>
                        <th align="left">Item</th>
                        <th align="left">Type</th>
                        <th align="left">Required</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td align="left">email</td>
                        <td align="left">String</td>
                        <td align="left">Yes</td>
                    </tr>
                    <tr>
                        <td align="left">password</td>
                        <td align="left">String</td>
                        <td align="left">Yes</td>
                    </tr>
                    </tbody>
                </table>


                <p><code>Example</code></p>

                <pre><code> curl -X POST \
   -H "Content-Type: application/json" \
   -d '{"email":"user1@sensoro.com","password":"123456"}' \
   https://cloud-api.sensoro.com/sessions/
</code></pre>

                <p><code>Response</code></p>


                <pre>
 <code>
 Status: 200 OK
 </code>
 </pre>

            </li>
        </ol>


        <h3>II. Yunzi Beacons</h3>

        <table>
            <thead>
            <tr>
                <th>URL</th>
                <th> HTTP</th>
                <th> Functionality</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>/users/me/beacons</td>
                <td> GET</td>
                <td> Device list</td>
            </tr>
            <tr>
                <td>/users/me/beacons</td>
                <td> POST</td>
                <td> Add Yunzi</td>
            </tr>
            <tr>
                <td>/users/me/beacons/:sn</td>
                <td> DELETE</td>
                <td> Delete Yunzi</td>
            </tr>
            <tr>
                <td>/users/me/beacons/:sn</td>
                <td> PUT</td>
                <td> Edit Yunzi's Tags</td>
            </tr>
            </tbody>
        </table>


        <ol>
            <li><p>Device list</p>

                <p><code>GET /users/me/beacons</code></p>

                <p><code>Example</code></p>

                <pre><code> curl -u user1@sensoro.com:123456 \
   -X GET \
   -H "Content-Type: application/json" \
   https://cloud-api.sensoro.com/users/me/beacons
</code></pre>

                <p><code>Response</code></p>


                <pre>
 <code>
 Status: 200 OK
 </code>
 </pre>
            </li>
            <li><p>Add Yunzi</p>

                <p><code>POST /users/me/beacons</code></p>

                <p><code>Parameters</code></p>

                <table>
                    <thead>
                    <tr>
                        <th align="left">Item</th>
                        <th align="left">Type</th>
                        <th align="left">Description</th>
                        <th align="left">Required</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td align="left">mac</td>
                        <td align="left">String</td>
                        <td align="left">mac address (SN)</td>
                        <td align="left">Yes</td>
                    </tr>
                    <tr>
                        <td align="left">token</td>
                        <td align="left">String</td>
                        <td align="left">validation key</td>
                        <td align="left">Yes</td>
                    </tr>
                    </tbody>
                </table>


                <p><code>Example</code></p>

                <pre><code> curl -u user1@sensoro.com:123456 \
   -X POST \
   -H "Content-Type: application/json" \
   -d '{"mac":"0117C5486322","token":"KfTNYy9tRzyOwNUG"}' \
   https://cloud-api.sensoro.com/users/me/beacons
</code></pre>

                <p><code>Response</code></p>

                <!--<p>-->
                <pre>
 <code>
 Status: 200 OK
     <!--</p>-->

                <p> {
                        "UMM": "63EA09C2-5345-4E6D-9776-26B9C6FC126C|2D03|00C3",
                        "mac": "0117C5486322",
                        "updatedTime": 1418269545245,
                        "users": [
                            {
                                "user": "53d5c846f3e54d2f4d42af8b",
                                "createdTime": "2014-12-11T03:53:40.120Z"
                            }
                        ],
                        "createTime": "2014-09-19T06:03:48.552Z",
                        "lonlat": [
                            116.475426,
                            39.993717
                        ],
                        "sensor": {
                            "accelerometer": 0,
                            "light": 153.36,
                            "power": 71,
                            "temperature": 19
                        }
                    }</p>

     <!--<p> -->
 </code>
                    </pre>
                <!--</p>-->
            </li>
            <li><p>Delete Yunzi</p>

                <p><code>DELETE /users/me/beacons/:sn</code></p>

                <p><code>Example</code></p>

                <pre><code> curl -u user1@sensoro.com:123456 \
   -X DELETE \
   -H "Content-Type: application/json" \
   https://cloud-api.sensoro.com/users/me/beacons/0117C5486322
</code></pre>

                <p><code>Response</code></p>

                <!--<p>-->
                <pre>
 <code>
 Status: 200 OK
 </code>
 </pre>
                <!--</p>-->
            </li>
            <li><p>Edit Yunzi's Tags</p>

                <p><code>PUT /users/me/beacons/:sn</code></p>

                <p><code>Parameters</code></p>

                <table>
                    <thead>
                    <tr>
                        <th align="left">Item</th>
                        <th align="left">Type</th>
                        <th align="left">Description</th>
                        <th align="left">Required</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td align="left">tags</td>
                        <td align="left">Array</td>
                        <td align="left">tag array</td>
                        <td align="left">Yes</td>
                    </tr>
                    </tbody>
                </table>


                <p><code>Example</code></p>

                <pre><code> curl -u user1@sensoro.com:123456 \
   -X PUT \
   -H "Content-Type: application/json" \
   -d '{"tags":["Beijing","WJ","SOHO","2807"]}' \
   https://cloud-api.sensoro.com/users/me/beacons/0117C5486322
</code></pre>

                <p><code>Response</code></p>

                <!--<p>-->
                <pre>
 <code>
 Status: 200 OK
 </code>
 </pre>
                <!--</p>-->
            </li>
        </ol>


        <h3>III. Inspection Logs</h3>

        <table>
            <thead>
            <tr>
                <th>URL</th>
                <th> HTTP</th>
                <th> Functionality</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>/users/me/beacons/logs</td>
                <td> GET</td>
                <td> Yunzi Logs</td>
            </tr>
            </tbody>
        </table>


        <ol>
            <li><p>/users/me/beacons/logs <code>GET</code></p>

                <p><code>Parameters</code></p>

                <table>
                    <thead>
                    <tr>
                        <th align="left">Item</th>
                        <th align="left">Type</th>
                        <th align="left">Description</th>
                        <th align="left">Required</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td align="left">type</td>
                        <td align="left">Int</td>
                        <td align="left">Source Type：<br>0: Data uploaded by all users<br>1: Data uploaded by the user
                            him/herself<br>2: Data uploaded by user's inspectors
                        </td>
                        <td align="left">No</td>
                    </tr>
                    <tr>
                        <td align="left">timestamp</td>
                        <td align="left">String</td>
                        <td align="left">timestamp</td>
                        <td align="left">No</td>
                    </tr>
                    <tr>
                        <td align="left">mac</td>
                        <td align="left">String</td>
                        <td align="left">mac address (SN)</td>
                        <td align="left">No</td>
                    </tr>
                    <tr>
                        <td align="left">page</td>
                        <td align="left">Int</td>
                        <td align="left">page，default value 0</td>
                        <td align="left">No</td>
                    </tr>
                    <tr>
                        <td align="left">count</td>
                        <td align="left">Int</td>
                        <td align="left">returned count，default value 100</td>
                        <td align="left">No</td>
                    </tr>
                    </tbody>
                </table>


                <p><code>Example</code></p>

                <pre><code> curl -u user1@sensoro.com:123456 \
   -X GET \
   -H "Content-Type: application/json" \
   https://cloud-api.sensoro.com/users/me/beacons/logs?mac=0117C5486322&amp;timestamp=1418279942
</code></pre>

                <p><code>Response</code></p>

                <!--<p>-->
                <pre>
 <code>
 Status: 200 OK
     <!--</p>-->

     <!--<p> -->
                    [
                        {
                            "beaconMac": "0117C5486322",
                            "beaconUMM": "63EA09C2-5345-4E6D-9776-26B9C6FC126C|2D03|00C3",
                            "__v": 0,
                            "updatedTime": 1418281671108,
                            "location": {
                            "lat": 39.99475475859843,
                            "lon": 116.4750352755154
                            },
                            "sensor": {
                                "temperature": 19,
                                "light": 22.14,
                                "power": 71,
                                "accelerometer": 0
                            }
                        }
                    ]
                    </code>
                    </pre>
                <!--</p>-->
            </li>
        </ol>


        <h3>IV. Deployment Maps</h3>

        <table>
            <thead>
            <tr>
                <th>URL</th>
                <th> HTTP</th>
                <th> Functionality</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>/maps/:key</td>
                <td> GET</td>
                <td> Data of designated deployment map</td>
            </tr>
            </tbody>
        </table>


        <ol>
            <li><p>Get Map Data</p>

                <p><code>GET /maps/:key</code></p>

                <p><code>Parameters</code></p>

                <table>
                    <thead>
                    <tr>
                        <th align="left">Item</th>
                        <th align="left">Type</th>
                        <th align="left">Description</th>
                        <th align="left">Required</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td align="left">key</td>
                        <td align="left">String</td>
                        <td align="left">Map ID</td>
                        <td align="left">Yes</td>
                    </tr>
                    </tbody>
                </table>


                <p><code>Example</code></p>

                <pre><code> curl -u user1@sensoro.com:123456 \
   -X GET \
   -H "Content-Type: application/json" \
   https://cloud-api.sensoro.com/maps/aNJGbkSj
</code></pre>

                <p><code>Response</code></p>

                <!--<p>-->
                    <pre>
 <code>
 Status: 200 OK


                <p>
                    {
                        "__v": 1,
                        "address": "Beijing WJ SOHO",
                        "description": "",
                        "floor": "F1",
                        "imageURL": "http://sensoro-maps.qiniudn.com/819a02a0d5b9a21e9ca8d186666280c1.png",
                        "key": "aNJGbkSj",
                        "name": "MapOne",
                        "user": "53d5c846f3e54d2f4d42af8b",
                        "createdTime": 1418280779158,
                        "beacons": [
                            {
                                "mac": "0117C5486322",
                                "PosX": 0.6781768,
                                "PosY": 0.40375,
                                "label": "",
                                "title": "",
                                "updatedTime": "2014-12-11T06:53:32.197Z",
                                "id": "54893f6c0c1bc56f4ecb9fde"
                            }
                        ],
                        "tags": [],
                        "yScale": 1,
                        "xScale": 1,
                        "id": "54893f4b0c1bc56f4ecb9fdd"
                    }
                </p>
                    </code>
                    </pre>
                <!--</p>-->
            </li>
        </ol>

    </div>
</template>

<script>
    export default {
        name: "rest-api"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/docs/restApi.vue